module.exports = __webpack_public_path__ + "static/media/295136.c718174f.png";